import React, { Component } from "react";

import { handleStepParam } from "./../../Utils/steps";

import queryString from "query-string";

import {
  newSearchURL,
  getClosest,
  getSiblings,
  findValueInArray
} from "./../../Utils";

export class StepOptionsRadio extends Component {
  state = {
    search: false
  };

  componentDidMount() {
    const { location, history } = this.props.props;

    if (location) {
      const { search, pathname } = location;

      const paramsURL = queryString.parse(search);

      const newURL = newSearchURL(
        `step${paramsURL.step}=empty`,
        `step${paramsURL.step}=0`,
        location
      );

      const selectDefaultValue = `${pathname}${newURL}`;

      history.push(selectDefaultValue);
    }
  }

  handleRadioButton = ev => {
    if (getClosest(ev.target, ".wizard-app-radio")) {
      let parent = getClosest(ev.target, ".wizard-app-radio");
      let siblings = getSiblings(parent);
      let i;
      for (i = 0; i < siblings.length; ++i) {
        siblings[i].querySelector(".card").classList.remove("active");
      }
      parent.querySelector(".card").classList.add("active");
      parent.querySelector("input").checked = true;
    }
  };

  handleStepParam = (ev, stepParamURL, props) => {
    const { history } = props;

    const newStepValue = handleStepParam(ev, stepParamURL, props);

    history.push(newStepValue);
  };

  render() {
    const { step, props } = this.props;
    

    const { location } = props;
    const { search } = location;

    const paramsURL = queryString.parse(search);
    const actualStepValue = paramsURL[`step${props.stepParamURL}`];

    return (
      <div data-test="StepOptionsRadioComponent">
        <div
          className="container-fluid card-holder"
        style={{ maxWidth: "600px" , margin: "0 auto" }}
        >
          <h1 className="d-none d-md-block header-step">Tú decides el acabado que más te va.</h1>
          <h6 className="text-uppercase font-weight-700 font-size-14px mb-4">Qué efecto quieres</h6>
          <div className="card-wizard">
            {step &&
              step.effects.map((effect, index) => {                
                const valueFinded =
                  actualStepValue &&
                  findValueInArray(actualStepValue.split(","), index);

                return (
                  <div
                    className="col-6 wizard-app-radio"
                    key={effect.ID}
                    data-radio={parseInt(valueFinded) === index && true}
                  >
                    <div
                      className={`card card-t1 card-radio w-100 ${parseInt(
                        valueFinded
                      ) === index && "active"}`}
                    >
                        <div className="helper">
                          {effect.badge && (
                            <span className="badge">
                              <img src={effect.badge} alt="New" />
                            </span>
                          )}
                          {effect.image && (
                            <img
                              src={effect.image}
                              className="card-img-top card-img img-height"
                              alt="Imagen"
                            />
                          )}
                          <div className="card-body">
                            <h5 className="card-title">
                              {effect.post_title}{" "}
                              <i
                                className="icon-info-circle icon-tooltip float-right"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Tooltip on top"
                              ></i>
                            </h5>
                            {effect.desc && (
                              <p className="card-text">{effect.desc}</p>
                            )}
                            {effect.info && (
                              <div className="note center-xs">{effect.info}</div>
                            )}
                            {effect.price && (
                              <div className="card-price-badge">
                                <span>+{effect.price}&euro;</span>
                              </div>
                            )}
                            <input
                              type="radio"
                              onChange={ev =>
                                this.handleStepParam(ev, props.stepParamURL, props)
                              }
                              name={`radioStep${props.stepParamURL}`}
                              value={index}
                              checked={parseInt(valueFinded) === index && true}
                            />
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    );
  }
}

export default StepOptionsRadio;
